<template>
  <div>
    <div class="back-to-top" v-if="isVisible" @click="scrollToTop">
      <div>
        <img class="pos-img1" src="@/assets/img/scrolltop.png" alt="" />
      </div>
      <span class="txt">{{ $t("home[8]") }}</span>
    </div>
    <div class="back-to-top pos" @click="gotourl">
      <div>
        <img class="pos-img" src="@/assets/img/lx.png" alt="" />
      </div>
      <span class="txt">{{ $t("home[7]") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    handleScroll() {
      // 当页面向下滚动超过 200 像素时，显示按钮
      this.isVisible = window.scrollY > 200;
    },
    gotourl() {
      window.open(
        "https://api.whatsapp.com/send/?phone=8613512282858&text&type=phone_number&app_absent=0"
      );
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll); // 组件销毁时移除监听
  },
};
</script>

<style scoped>
.back-to-top {
  position: fixed;
  bottom: 116px;
  right: 20px;
  background-color: #a7986d;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 16px;
  width: 56px;
  height: 56px;
}
.pos {
  bottom: 52px;
}
.txt {
  font-size: 14px;
}
.pos-img1 {
  width: 20px;
}
.pos-img {
  width: 20px;
  /* transform-origin: center top; */
  animation: left-Right-shaking 1s infinite ease-in-out;
}
@keyframes left-Right-shaking {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(12deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-12deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

/* .back-to-top:hover {
  background-color: #0056b3; 
} */
</style>
